import { render, staticRenderFns } from "./ListagemEntidadesHeader.vue?vue&type=template&id=4d629d6e"
import script from "./ListagemEntidadesHeader.vue?vue&type=script&lang=js"
export * from "./ListagemEntidadesHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports